<app-view
  [justify]="ViewJustify.SPACE_BETWEEN"
  [spacingBottom]="Spacing.SMALL"
  [gap]="Spacing.MEDIUM_SMALL"
>
  <app-secondary-navigation
    [links]="links"
    data-test-id="tenant-configuration-secondary-nav"
    [spacingBottom]="Spacing.NONE"
  ></app-secondary-navigation>
  @if (routeView() === '/tenant-configuration/general') {
  <app-button
    [type]="'primary'"
    (handleClick)="handleAddNewTenantDialog()"
    data-test-id="general-add-tenant-button"
    [spacingBottom]="Spacing.NONE"
    [disabled]="!this.tenantConfigurationService.isReadMode()"
    >{{ 'tenantConfiguration.general.addTenant' | translate }}</app-button
  >
  } @else if (routeView() === '/tenant-configuration/contracts') {
  <app-button
    [type]="'primary'"
    (handleClick)="handleAddNewContractDialog()"
    [disabled]="!this.tenantConfigurationService.isReadMode()"
    [spacingBottom]="Spacing.NONE"
    data-test-id="tenant-add-new-contract-button"
    >{{ 'tenantConfiguration.contracts.addContract' | translate }}</app-button
  >
  }
</app-view>
<router-outlet
  (activate)="onActivate()"
  data-test-id="tenant-configuration-router-outlet"
></router-outlet>
<app-save-changes-confirmation></app-save-changes-confirmation>
